"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[515],{

/***/ 2503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(120);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(754);
/* harmony import */ var src_layouts_components_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4381);
// ** MUI Imports



// ** Source code Imports

const FallbackSpinner = (param)=>{
    let { sx , settings  } = param;
    const { mode  } = settings;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            height: "100vh",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            ...sx
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_components_icons__WEBPACK_IMPORTED_MODULE_1__/* .Logotype */ .Vp, {
                width: 82,
                height: 68,
                mode: mode
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                disableShrink: true,
                sx: {
                    mt: 6
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FallbackSpinner);


/***/ }),

/***/ 8958:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    space: "silk" || 0,
    apiEndpoint: "https://api.emd.one" || 0,
    bucketUrl: "https://static.emd.one/silk/application",
    landingUrl: "https://".concat("gosilk.ru") || 0
});


/***/ }),

/***/ 1872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ db_columns_keys; }
});

;// CONCATENATED MODULE: ./src/configs/db-columns-keys/prod.json
var prod_namespaceObject = JSON.parse('{"keyValues":{"language":"col_85c079dae6"},"landing_how_work_it":{"language":"col_c3507b25d2","description":"col_f1b108a5e9"},"controls_slides":{"order":"col_676b520e74","language":"col_12c5863f3c"},"landing_platforms":{"language":"col_a91690b2e7"},"landing_platform_slides":{"language":"col_41d62be276","order":"col_ed61b44bf4","imageUrl":"col_bd972afb0b"},"landing_artists_slider":{"language":"col_67d0d808fb","imageUrl":"col_2d2f58ee7b","playsPerMonth":"col_935455cc58","since":"col_be8b741b3c","yandexMusicUrl":"col_1e1aa80402","appleMusicUrl":"col_b3d54aef25","vkMusicUrl":"col_7274dfc5dc","youtubeMusicUrl":"col_63b873c02a","spotifyUrl":"col_9386d789bb","deezerUrl":"col_df80dac010"},"landing_partners_slides":{"name":"col_8967b47224","description":"col_a36c94ffe1","img":"col_12950a7268"}}');
;// CONCATENATED MODULE: ./src/configs/db-columns-keys/stage.json
var stage_namespaceObject = JSON.parse('{"keyValues":{"language":"col_b892af1319"},"landing_how_work_it":{"language":"col_a9f2f92cc9","description":"col_33237002f4"},"controls_slides":{"order":"col_9e6bfe4cbc","language":"col_5bd8a45111"},"landing_platforms":{"language":"col_4854710794"},"landing_platform_slides":{"language":"col_36e51bd15c","order":"col_08ffa25c6e","imageUrl":"col_f21aa1f081"},"landing_artists_slider":{"language":"col_966fb878d8","imageUrl":"col_fe840ef53e","playsPerMonth":"col_04d97887ea","since":"col_8a275f9667","yandexMusicUrl":"col_9930c64441","appleMusicUrl":"col_574fc60785","vkMusicUrl":"col_c74a0ca61e","youtubeMusicUrl":"col_3651418d66","spotifyUrl":"col_d60773b0a2","deezerUrl":"col_787d707c13"},"landing_partners_slides":{"name":"col_f105ce1335","description":"col_8415868ee7","img":"col_8ee111347a"}}');
;// CONCATENATED MODULE: ./src/configs/db-columns-keys/index.ts


const environment = "prod";
const config = {
    prod: prod_namespaceObject,
    stage: stage_namespaceObject
};
const tableColumnKeysConf = environment ? config[environment] : stage_namespaceObject;
/* harmony default export */ var db_columns_keys = (tableColumnKeysConf);


/***/ }),

/***/ 662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ db_enum_v2_options; }
});

;// CONCATENATED MODULE: ./src/configs/db-enum-v2-options/prod.json
var prod_namespaceObject = JSON.parse('{"keyValues":{"language":{"ru":"e658db6a-ba2c-4edb-85a8-f3d1e4bb3f8e","en":"936cad8e-cdec-4ca3-8083-7dbe86f744d9"}},"landing_how_work_it":{"language":{"ru":"02672db0-d1dd-4c15-881f-a20cb409be6b","en":"a96af4d5-de80-4e99-b5cc-7e0c9b4eb37b"}},"controls_slides":{"language":{"ru":"058c3f38-a046-4c0e-8084-07d44ac8e821","en":"259a61be-f9f5-4375-be0c-9a9770984f2f"}},"landing_platforms":{"language":{"ru":"85286810-446f-44c6-a9fa-a56b631cef09","en":"e6aa8d43-de00-447a-a920-ab74031a9012"}},"landing_platform_slides":{"language":{"ru":"64ff6c8f-a31c-4d91-aaad-a98f9b77b5cd","en":"d2138b96-df7b-45be-9ead-2fd5c1a1e1a3"}},"landing_artists_slider":{"language":{"ru":"8d232c48-5fc8-4419-a82c-348b2921a317","en":"8581d3cd-f4ad-4316-acbf-a65f48bce034"}}}');
;// CONCATENATED MODULE: ./src/configs/db-enum-v2-options/stage.json
var stage_namespaceObject = JSON.parse('{"keyValues":{"language":{"ru":"9a0f4ffc-7eea-48a9-8eba-8dcc264ba2f2","en":"244a65d5-cecb-4d2c-9a46-802010c91fbd"}},"landing_how_work_it":{"language":{"ru":"0145ca5d-2d0a-4566-b205-fbce1873080d","en":"55d60bf4-c379-412d-87ae-bf70ad79ab09"}},"controls_slides":{"language":{"ru":"1659c103-4324-4816-bebe-50e30b3e0553","en":"947a142d-24c9-45d2-9c8e-477a83314f59"}},"landing_platforms":{"language":{"ru":"f77d9261-5a8a-412b-aee4-6f8dd0215a23","en":"641c0177-781c-4ff7-a66a-6fa0b31a1c7e"}},"landing_platform_slides":{"language":{"ru":"4d5be433-3a70-4105-8907-c93bd0730ae2","en":"7327e8c8-9cb3-46bb-8e97-35ca908b992b"}},"landing_artists_slider":{"language":{"ru":"063c246d-7a41-43fd-8de0-81c43f3950f3","en":"59d32ced-e503-45d1-8a77-4c5944de9b48"}}}');
;// CONCATENATED MODULE: ./src/configs/db-enum-v2-options/index.ts


const environment = "prod";
const config = {
    prod: prod_namespaceObject,
    stage: stage_namespaceObject
};
const tableEnumV2OptionsConf = environment ? config[environment] : stage_namespaceObject;
/* harmony default export */ var db_enum_v2_options = (tableEnumV2OptionsConf);


/***/ }),

/***/ 4381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vp": function() { return /* reexport */ icons_Logotype; }
});

// UNUSED EXPORTS: CountrieFlag, PlatformIcon

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(1645);
;// CONCATENATED MODULE: ./src/layouts/components/icons/Logotype.tsx
// ** React Imports


// ** MUI Imports

const Logotype = (param)=>{
    let { mode ="dark" , width ="100%" , height ="100%" , sx  } = param;
    const fill = {
        light: "#141414",
        dark: "#FFFFFF",
        "semi-dark": "#FFFFFF"
    }[mode];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, {
        sx: {
            transition: "200ms",
            width,
            height,
            ...sx
        },
        width: width,
        height: height,
        style: {
            transition: "200ms"
        },
        viewBox: "0 0 43 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.1417 0.664994C13.2848 1.12009 14.3264 1.81063 15.2031 2.69459L12.9799 5.38571C11.7427 4.27374 10.1635 3.65147 8.52363 3.62973C7.8232 3.59029 7.1279 3.77406 6.53188 4.15618C6.29405 4.32607 6.1021 4.55582 5.97419 4.82369C5.84628 5.09156 5.78664 5.38871 5.8009 5.68703C5.78717 6.09262 5.90521 6.4913 6.13621 6.81959C6.44789 7.18668 6.83989 7.47166 7.27962 7.65081C8.07615 8.0133 8.89233 8.32782 9.72405 8.59292C11.7918 9.28556 13.3152 10.1284 14.2944 11.1212C15.2735 12.1141 15.7619 13.5307 15.7597 15.3709C15.7821 16.5994 15.4455 17.8064 14.7939 18.8344C14.1031 19.8714 13.1366 20.6797 12.0109 21.1618C10.6508 21.7497 9.18617 22.0353 7.71221 22C6.2025 22.0294 4.70197 21.7517 3.29612 21.1826C2.07461 20.6769 0.95637 19.9378 0 19.0041L2.43101 16.2506C3.1503 16.8969 3.96691 17.4175 4.84861 17.7919C5.71141 18.1414 6.63117 18.3166 7.55791 18.308C8.39271 18.3493 9.2175 18.1059 9.90515 17.6153C10.1863 17.3957 10.4116 17.1089 10.5617 16.7795C10.7118 16.4501 10.7822 16.0879 10.7669 15.7242C10.7791 15.2614 10.6627 14.8047 10.4316 14.408C10.1476 13.9954 9.7637 13.667 9.31834 13.4556C8.58308 13.0877 7.81919 12.7842 7.03485 12.5482C4.80391 11.8486 3.21564 10.9838 2.27006 9.95406C1.79622 9.43193 1.42674 8.81842 1.18278 8.14867C0.938815 7.47884 0.825163 6.76593 0.84834 6.0507C0.827236 4.91167 1.1559 3.79499 1.78721 2.86084C2.44634 1.91479 3.35058 1.18008 4.39595 0.741189C5.59316 0.229401 6.8794 -0.0228753 8.17488 6.6165e-06C9.52536 -0.0302739 10.8698 0.195105 12.1417 0.664994Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.6781 21.4735H16.873V11H21.6781V21.4735Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.0423 21.4736H23.2373V6.07495H28.0423V21.4736Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.2523 21.4736H29.4473V0.516113H34.2523V21.4736Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M37.5953 0.16626L29.4473 10.6502L34.2489 10.6536L42.4004 0.169723L37.5953 0.16626Z",
                fill: "#9000FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.317 9.45535L21.6709 8.29852L16.876 5.94336V10.6537L19.317 9.45535Z",
                fill: fill
            })
        ]
    });
};
/* harmony default export */ var icons_Logotype = (Logotype);

// EXTERNAL MODULE: ./node_modules/react-world-flags/dist/react-world-flags.js
var react_world_flags = __webpack_require__(5633);
;// CONCATENATED MODULE: ./src/configs/ISO3166-1.alpha2.ts
/* harmony default export */ var ISO3166_1_alpha2 = ({
    afghanistan: "AF",
    "aland-islands": "AX",
    albania: "AL",
    algeria: "DZ",
    "american-samoa": "AS",
    andorra: "AD",
    angola: "AO",
    anguilla: "AI",
    antarctica: "AQ",
    "antigua-and-barbuda": "AG",
    argentina: "AR",
    armenia: "AM",
    aruba: "AW",
    australia: "AU",
    austria: "AT",
    azerbaijan: "AZ",
    bahamas: "BS",
    bahrain: "BH",
    bangladesh: "BD",
    barbados: "BB",
    belarus: "BY",
    belgium: "BE",
    belize: "BZ",
    benin: "BJ",
    bermuda: "BM",
    bhutan: "BT",
    bolivia: "BO",
    "bosnia-and-herzegovina": "BA",
    botswana: "BW",
    "bouvet-island": "BV",
    brazil: "BR",
    "british-indian-ocean-territory": "IO",
    brunei: "BN",
    bulgaria: "BG",
    "burkina-faso": "BF",
    burundi: "BI",
    cambodia: "KH",
    cameroon: "CM",
    canada: "CA",
    "cape-verde": "CV",
    "cayman-islands": "KY",
    "central-african-republic": "CF",
    chad: "TD",
    chile: "CL",
    china: "CN",
    "christmas-island": "CX",
    "cocos-keeling-islands": "CC",
    colombia: "CO",
    comoros: "KM",
    congo: "CG",
    "congo-democratic-republic": "CD",
    "cook-islands": "CK",
    "costa-rica": "CR",
    "cote-divoire": "CI",
    croatia: "HR",
    cuba: "CU",
    cyprus: "CY",
    "czech-republic": "CZ",
    denmark: "DK",
    djibouti: "DJ",
    dominica: "DM",
    "dominican-republic": "DO",
    ecuador: "EC",
    egypt: "EG",
    "el-salvador": "SV",
    "equatorial-guinea": "GQ",
    eritrea: "ER",
    estonia: "EE",
    ethiopia: "ET",
    "falkland-islands": "FK",
    "faroe-islands": "FO",
    fiji: "FJ",
    finland: "FI",
    france: "FR",
    "french-guiana": "GF",
    "french-polynesia": "PF",
    "french-southern-territories": "TF",
    gabon: "GA",
    gambia: "GM",
    georgia: "GE",
    germany: "DE",
    ghana: "GH",
    gibraltar: "GI",
    greece: "GR",
    greenland: "GL",
    grenada: "GD",
    guadeloupe: "GP",
    guam: "GU",
    guatemala: "GT",
    guernsey: "GG",
    guinea: "GN",
    "guinea-bissau": "GW",
    guyana: "GY",
    haiti: "HT",
    "heard-island-&-mcdonald-islands": "HM",
    "holy-see-vatican-city-state": "VA",
    honduras: "HN",
    "hong-kong": "HK",
    hungary: "HU",
    iceland: "IS",
    india: "IN",
    indonesia: "ID",
    "ivory-coast": "IE",
    iran: "IR",
    iraq: "IQ",
    ireland: "IE",
    "isle-of-man": "IM",
    israel: "IL",
    italy: "IT",
    jamaica: "JM",
    japan: "JP",
    jersey: "JE",
    jordan: "JO",
    kazakhstan: "KZ",
    kenya: "KE",
    kiribati: "KI",
    "south-korea": "KR",
    "north-korea": "KP",
    kuwait: "KW",
    kyrgyzstan: "KG",
    laos: "LA",
    latvia: "LV",
    lebanon: "LB",
    lesotho: "LS",
    liberia: "LR",
    "libyan-arab-jamahiriya": "LY",
    liechtenstein: "LI",
    lithuania: "LT",
    luxembourg: "LU",
    macao: "MO",
    macedonia: "MK",
    madagascar: "MG",
    malawi: "MW",
    malaysia: "MY",
    maldives: "MV",
    mali: "ML",
    malta: "MT",
    "marshall-islands": "MH",
    martinique: "MQ",
    mauritania: "MR",
    mauritius: "MU",
    mayotte: "YT",
    mexico: "MX",
    "micronesia-federated-states-of": "FM",
    moldova: "MD",
    monaco: "MC",
    mongolia: "MN",
    montenegro: "ME",
    montserrat: "MS",
    morocco: "MA",
    mozambique: "MZ",
    myanmar: "MM",
    namibia: "NA",
    nauru: "NR",
    nepal: "NP",
    netherlands: "NL",
    "netherlands-antilles": "AN",
    "new-caledonia": "NC",
    "new-zealand": "NZ",
    nicaragua: "NI",
    niger: "NE",
    nigeria: "NG",
    niue: "NU",
    "norfolk-island": "NF",
    "northern-mariana-islands": "MP",
    norway: "NO",
    oman: "OM",
    pakistan: "PK",
    palau: "PW",
    palestine: "PS",
    panama: "PA",
    "papua-new-guinea": "PG",
    paraguay: "PY",
    peru: "PE",
    philippines: "PH",
    pitcairn: "PN",
    poland: "PL",
    portugal: "PT",
    "puerto-rico": "PR",
    qatar: "QA",
    reunion: "RE",
    romania: "RO",
    "russian-federation": "RU",
    rwanda: "RW",
    "saint-barthelemy": "BL",
    "saint-helena": "SH",
    "saint-kitts-and-nevis": "KN",
    "saint-lucia": "LC",
    "saint-martin": "MF",
    "saint-pierre-and-miquelon": "PM",
    "saint-vincent-and-grenadines": "VC",
    samoa: "WS",
    "san-marino": "SM",
    "sao-tome-and-principe": "ST",
    "saudi-arabia": "SA",
    senegal: "SN",
    serbia: "RS",
    seychelles: "SC",
    "sierra-leone": "SL",
    singapore: "SG",
    slovakia: "SK",
    slovenia: "SI",
    "solomon-islands": "SB",
    somalia: "SO",
    "south-africa": "ZA",
    "south-sudan": "SS",
    "south-georgia-and-sandwich-islands": "GS",
    spain: "ES",
    "sri-lanka": "LK",
    sudan: "SD",
    suriname: "SR",
    "svalbard-and-jan-mayen": "SJ",
    swaziland: "SZ",
    sweden: "SE",
    switzerland: "CH",
    syria: "SY",
    taiwan: "TW",
    tajikistan: "TJ",
    tanzania: "TZ",
    thailand: "TH",
    "timor-leste": "TL",
    togo: "TG",
    tokelau: "TK",
    tonga: "TO",
    "trinidad-and-tobago": "TT",
    tunisia: "TN",
    turkey: "TR",
    turkmenistan: "TM",
    "turks-and-caicos-islands": "TC",
    tuvalu: "TV",
    uganda: "UG",
    ukraine: "UA",
    "united-arab-emirates": "AE",
    "united-kingdom": "GB",
    "united-states": "US",
    "united-states-minor-outlying-islands": "UM",
    uruguay: "UY",
    uzbekistan: "UZ",
    vanuatu: "VU",
    venezuela: "VE",
    vietnam: "VN",
    "virgin-islands-british": "VG",
    "virgin-islands-us": "VI",
    "wallis-and-futuna": "WF",
    "western-sahara": "EH",
    yemen: "YE",
    zambia: "ZM",
    zimbabwe: "ZW"
});

;// CONCATENATED MODULE: ./src/layouts/components/icons/CountrieFlag.tsx



const CountrieFlag = (param)=>{
    let { name , width , height , ...props } = param;
    if (!ISO3166[name]) return null;
    return /*#__PURE__*/ _jsx(Flag, {
        width: width,
        height: height,
        ...props,
        code: ISO3166[name]
    });
};
/* harmony default export */ var icons_CountrieFlag = ((/* unused pure expression or super */ null && (CountrieFlag)));

;// CONCATENATED MODULE: ./src/layouts/components/icons/PlatformIcon.tsx

const PlatformIcon = (param)=>{
    let { id , size =24 , style ={}  } = param;
    if (id === "appleMusic") return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        style: style,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                "clip-path": "url(#clip0_363_17431)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M24 7.50751C24 7.22083 24 6.93416 23.9987 6.64749C23.9973 6.40615 23.9947 6.16481 23.988 5.92347C23.974 5.39746 23.9427 4.86745 23.8493 4.34743C23.7547 3.81942 23.5993 3.32808 23.3553 2.84807C23.1153 2.37672 22.802 1.94605 22.428 1.57204C22.054 1.19803 21.6227 0.884687 21.1513 0.644682C20.672 0.400676 20.1807 0.246006 19.6533 0.15067C19.1333 0.0573347 18.6027 0.0260006 18.0767 0.0120003C17.8353 0.00533346 17.594 0.00266673 17.3527 0.00133336C17.066 0 16.7793 0 16.4927 0H7.50733C7.22067 0 6.934 0 6.64733 0.00133336C6.406 0.00266673 6.16467 0.00533346 5.92333 0.0120003C5.39733 0.0266673 4.86667 0.0573347 4.34667 0.151337C3.81867 0.246006 3.328 0.401343 2.84867 0.645348C2.37733 0.885354 1.946 1.19869 1.572 1.5727C1.198 1.94671 0.884667 2.37739 0.644667 2.84873C0.400667 3.32874 0.245333 3.82009 0.150667 4.3481C0.0573333 4.86811 0.026 5.39879 0.012 5.92414C0.00533333 6.16548 0.00266667 6.40682 0.00133333 6.64815C0 6.93416 0 7.22083 0 7.50751V16.4924C0 16.7791 0 17.0657 0.00133333 17.3524C0.00266667 17.5937 0.00533333 17.8351 0.012 18.0764C0.026 18.6024 0.0573333 19.1324 0.150667 19.6525C0.245333 20.1805 0.400667 20.6718 0.644667 21.1518C0.884667 21.6232 1.198 22.0538 1.572 22.4279C1.946 22.8019 2.37733 23.1152 2.84867 23.3552C3.328 23.5992 3.81933 23.7539 4.34667 23.8492C4.86667 23.9426 5.39733 23.9739 5.92333 23.9879C6.16467 23.9946 6.406 23.9972 6.64733 23.9986C6.934 24.0006 7.22067 23.9999 7.50733 23.9999H16.492C16.7787 23.9999 17.0653 23.9999 17.352 23.9986C17.5933 23.9972 17.8347 23.9946 18.076 23.9879C18.602 23.9739 19.1327 23.9426 19.6527 23.8492C20.1807 23.7546 20.6713 23.5992 21.1507 23.3552C21.622 23.1152 22.0533 22.8019 22.4273 22.4279C22.8013 22.0538 23.1147 21.6232 23.3547 21.1518C23.5987 20.6718 23.754 20.1805 23.8487 19.6525C23.942 19.1324 23.9733 18.6018 23.9873 18.0764C23.994 17.8351 23.9967 17.5937 23.998 17.3524C24 17.0657 23.9993 16.7791 23.9993 16.4924V7.50751H24Z",
                        fill: "url(#paint0_linear_363_17431)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.9197 3.65673C16.8619 3.66205 16.348 3.75313 16.2861 3.76576L9.17256 5.20111L9.1699 5.20177C8.98442 5.241 8.83882 5.30682 8.72647 5.40122C8.59085 5.5149 8.51572 5.67579 8.48713 5.86327C8.48115 5.90316 8.47118 5.98427 8.47118 6.10394C8.47118 6.10394 8.47118 13.3717 8.47118 15.0072C8.47118 15.2153 8.45456 15.4174 8.31362 15.5896C8.17267 15.7618 7.99849 15.8136 7.79439 15.8548C7.63949 15.8861 7.48459 15.9173 7.32968 15.9486C6.74198 16.0669 6.35971 16.1474 6.01334 16.2817C5.68226 16.41 5.43428 16.5735 5.23683 16.7809C4.84525 17.1911 4.68636 17.7476 4.74087 18.2688C4.78741 18.7136 4.98752 19.1391 5.33123 19.4535C5.56326 19.6663 5.85312 19.8278 6.19483 19.8963C6.54918 19.9674 6.9268 19.9428 7.4786 19.8311C7.77245 19.772 8.04769 19.6796 8.30963 19.5247C8.56891 19.3717 8.79096 19.1676 8.96447 18.919C9.13866 18.6697 9.25101 18.3925 9.31284 18.098C9.37666 17.7941 9.39195 17.5196 9.39195 17.2164V9.49452C9.39195 9.081 9.50896 8.97197 9.8427 8.89086C9.8427 8.89086 15.7556 7.69817 16.0315 7.64432C16.4164 7.57053 16.5979 7.68022 16.5979 8.08377V13.3551C16.5979 13.5639 16.5959 13.7753 16.4537 13.9481C16.3127 14.1203 16.1385 14.1722 15.9344 14.2134C15.7795 14.2447 15.6246 14.2759 15.4697 14.3071C14.882 14.4255 14.4998 14.5059 14.1534 14.6402C13.8223 14.7685 13.5743 14.9321 13.3769 15.1395C12.9853 15.5497 12.8125 16.1062 12.867 16.6274C12.9135 17.0721 13.1276 17.4976 13.4713 17.8121C13.7033 18.0248 13.9932 18.1817 14.3349 18.2509C14.6892 18.322 15.0669 18.2967 15.6187 18.1857C15.9125 18.1265 16.1877 18.0381 16.4497 17.8832C16.709 17.7303 16.931 17.5262 17.1045 17.2776C17.2787 17.0283 17.3911 16.751 17.4529 16.4565C17.5167 16.1527 17.5194 15.8781 17.5194 15.575V4.28565C17.5207 3.87612 17.3046 3.62349 16.9197 3.65673Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_363_17431",
                        x1: "12",
                        y1: "23.9075",
                        x2: "12",
                        y2: "0.517251",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                "stop-color": "#FA233B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                "stop-color": "#FB5C74"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_363_17431",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
    if (id === "vkMusic") return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        style: style,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                "clip-path": "url(#clip0_363_17432)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3.69822 0H20.3018C22.3442 0 24 1.65576 24 3.69822V20.3018C24 22.3442 22.3442 24 20.3018 24H3.69822C1.65576 24 0 22.3442 0 20.3018V3.69822C0 1.65576 1.65576 0 3.69822 0Z",
                        fill: "#4C75A3"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7989 16.8007H12.7806C12.7806 16.8007 13.0771 16.768 13.2287 16.6049C13.368 16.455 13.3635 16.1737 13.3635 16.1737C13.3635 16.1737 13.3443 14.8564 13.9556 14.6624C14.5584 14.4712 15.3324 15.9355 16.1526 16.4986C16.7729 16.9246 17.2443 16.8313 17.2443 16.8313L19.4378 16.8007C19.4378 16.8007 20.5851 16.7299 20.0411 15.8277C19.9965 15.7541 19.7241 15.1604 18.4101 13.9408C17.0346 12.6642 17.219 12.8707 18.8758 10.6626C19.8847 9.31779 20.288 8.49685 20.162 8.14525C20.0419 7.81026 19.2998 7.89875 19.2998 7.89875L16.8301 7.91402C16.8301 7.91402 16.6469 7.88909 16.5112 7.9703C16.3785 8.04971 16.2933 8.23525 16.2933 8.23525C16.2933 8.23525 15.9022 9.2758 15.3811 10.1609C14.2814 12.0282 13.8416 12.127 13.6619 12.0109C13.2436 11.7406 13.3481 10.9254 13.3481 10.346C13.3481 8.53629 13.6226 7.78175 12.8136 7.58643C12.5452 7.52166 12.3475 7.4788 11.6609 7.4718C10.7796 7.46283 10.0339 7.47452 9.61159 7.6814C9.33061 7.819 9.11384 8.12553 9.24594 8.14317C9.40921 8.16492 9.77879 8.24294 9.97474 8.50957C10.2279 8.85399 10.219 9.62715 10.219 9.62715C10.219 9.62715 10.3645 11.7575 9.87943 12.022C9.54658 12.2035 9.0899 11.833 8.10944 10.1388C7.60719 9.27105 7.22783 8.31171 7.22783 8.31171C7.22783 8.31171 7.15478 8.13247 7.0243 8.03652C6.86606 7.92027 6.64495 7.88343 6.64495 7.88343L4.29804 7.89875C4.29804 7.89875 3.94581 7.90858 3.81637 8.0618C3.70122 8.19818 3.80718 8.4799 3.80718 8.4799C3.80718 8.4799 5.64443 12.7785 7.72494 14.9447C9.63281 16.931 11.7989 16.8007 11.7989 16.8007Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_363_17432",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
    return null;
};
/* harmony default export */ var icons_PlatformIcon = ((/* unused pure expression or super */ null && (PlatformIcon)));

;// CONCATENATED MODULE: ./src/layouts/components/icons/index.ts






/***/ }),

/***/ 2088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ state_manager_landing; },
  "d_": function() { return /* binding */ getLandingDetail; },
  "hg": function() { return /* binding */ getTableForLanding; }
});

// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(196);
// EXTERNAL MODULE: ./node_modules/effector/effector.mjs
var effector = __webpack_require__(8116);
// EXTERNAL MODULE: ./src/configs/api.ts
var api = __webpack_require__(8958);
;// CONCATENATED MODULE: ./src/configs/landing.tsx

/* harmony default export */ var landing = ({
    getTable: (tableName)=>"".concat(api/* default.apiEndpoint */.Z.apiEndpoint, "/api/").concat(api/* default.space */.Z.space, "/database/").concat(tableName, "/row")
});

;// CONCATENATED MODULE: ./src/state-manager/landing/index.ts



const getTableForLanding = (0,effector/* createEffect */.GW)(async (param)=>{
    let { tableName , key , query ={} , sort =[] , page =0 , limit =100  } = param;
    const { data  } = await axios/* default.post */.ZP.post(landing.getTable(tableName), {
        query,
        sort,
        page,
        limit
    });
    return {
        data,
        key
    };
});
const getLandingDetail = (0,effector/* createEffect */.GW)(async (payload)=>{
    var ref;
    const res = await axios/* default.post */.ZP.post(landing.getTable("keyValues"), payload);
    const data = {};
    (ref = res.data) === null || ref === void 0 ? void 0 : ref.data.forEach((item)=>{
        const { key , value  } = item.data;
        data[key] = value;
    });
    return data;
});
const landing_landing = (0,effector/* createStore */.MT)({
    name: "string",
    artistsItems: {
        data: [],
        loading: true
    },
    workItItems: {
        data: [],
        loading: true
    },
    platforms: {
        loading: true,
        data: []
    },
    platformSlides: {
        loading: true,
        data: []
    },
    faqItems: {
        loading: true,
        data: []
    },
    controlsSlides: {
        loading: true,
        data: []
    },
    landingDetails: {
        loading: true,
        data: {}
    },
    partnersItems: {
        loading: true,
        data: []
    }
}).on(getTableForLanding, (state)=>{
    return {
        ...state,
        artists: {
            ...state.artists,
            loading: true
        }
    };
}).on(getTableForLanding.doneData, (state, param)=>{
    let { key , data: payload  } = param;
    return {
        ...state,
        [key]: {
            data: payload.data,
            loading: false
        }
    };
}).on(getLandingDetail, (state)=>{
    return {
        ...state,
        landingDetails: {
            ...state.landingDetails,
            loading: true
        }
    };
}).on(getLandingDetail.doneData, (state, payload)=>{
    return {
        ...state,
        landingDetails: {
            loading: false,
            data: payload
        }
    };
});

/* harmony default export */ var state_manager_landing = ({
    landing: landing_landing
});


/***/ })

}]);